<div class="side-nav" sideNav style="background-color: #fff;">
    <ul class="ant-menu ant-menu-root ant-menu-inline side-nav-menu" [ngClass]="{
            'ant-menu-inline-collapsed': isFolded,
            'ant-menu-dark' : isSideNavDark
        }">
        <li [ngClass]="item.submenu.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
            *ngFor="let item of menuItems"
            [routerLinkActive]="item.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
            [routerLinkActiveOptions]="{exact: true}">
            <a href="javascript:void(0);" class="ant-menu-submenu-title"
                *ngIf="item.submenu.length > 0 && userData.role == item.role">
                <i *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" [theme]="item.iconTheme"></i>
                <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
                <span>{{item.title}}</span>
                <i class="ant-menu-submenu-arrow new_sec_icon"></i>
            </a>

            <a class="menu-list" (click)="closeMobileMenu()" *ngIf="item.submenu.length === 0 && item.iconType !== '' ">
                <a [routerLink]="item.path">
                    <div class="">
                        <i *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" [theme]="item.iconTheme"></i>
                        <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10"
                            [ngClass]="[item.iconTheme , item.icon]"></i>
                        <span>{{item.title}}</span>
                    </div>
                </a>
                <div *ngIf="item.path !=='/receipts' && item.path !=='/payment' && item.path !=='/sales-report' && item.path !== '/purchase-report'"
                    class="addbutton">
                    <span (click)="showForm(item.path)" *ngIf="item.title !=='Dashboard' && item.title!=='Reports'"><i
                            nz-icon nzType="plus-circle" nzTheme="outline"></i></span>
                </div>
            </a>


            <a class="" *ngIf="item.iconType == ''">
                <div class="heading-text">
                    <i *ngIf="item.iconType == 'nzIcon'" nz-icon [nzType]="item.icon" [theme]="item.iconTheme"></i>
                    <i *ngIf="item.iconType == 'fontawesome'" class="m-r-10"
                        [ngClass]="[item.iconTheme , item.icon]"></i>
                    <span>{{item.title}}</span>
                </div>
                <div class="addbutton">
                    <span (click)="showForm(item.path)" *ngIf="item.title !=='Dashboard' && item.title!=='Reports'"><i
                            nz-icon nzType="plus-circle" nzTheme="outline"></i></span>
                </div>
            </a>



            <!-- Second Level -->
            <ul class="ant-menu ant-menu-inline new_secondary_ul ant-menu-sub dropdown-menu"
                *ngIf="item.submenu.length > 0 && userData.role == item.role" style="background-color: #03500a;">
                <li [ngClass]="subItem.submenu.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                    *ngFor="let subItem of item.submenu"
                    [routerLinkActive]="subItem.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
                    [routerLinkActiveOptions]="{exact: true}">
                    <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-50"
                        *ngIf="subItem.submenu.length > 0">
                        <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon"
                            [theme]="subItem.iconTheme"></i>
                        <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10"
                            [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                        <span>{{subItem.title}}</span>
                        <i class="ant-menu-submenu-arrow"></i>
                    </a>
                    <a [routerLink]="subItem.path" (click)="closeMobileMenu()" class="side_nav_sub_menu"
                        *ngIf="subItem.submenu.length === 0">
                        <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon"
                            [theme]="subItem.iconTheme"></i>
                        <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10"
                            [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                        <span>{{subItem.title}}</span>
                    </a>


                    <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" *ngIf="subItem.submenu.length > 0">
                        <li [ngClass]="subItem.submenu.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                            *ngFor="let subItem of subItem.submenu" routerLinkActive="ant-menu-item-selected"
                            [routerLinkActiveOptions]="{exact: true}">
                            <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-50"
                                *ngIf="subItem.submenu.length > 0">
                                <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon"
                                    [theme]="subItem.iconTheme"></i>
                                <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10"
                                    [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                                <span>{{subItem.title}}</span>
                                <i class="ant-menu-submenu-arrow"></i>
                            </a>
                            <a [routerLink]="subItem.path" (click)="closeMobileMenu()" class="p-l-50"
                                *ngIf="subItem.submenu.length === 0">
                                <i *ngIf="subItem.iconType == 'nzIcon'" nz-icon [nzType]="subItem.icon"
                                    [theme]="subItem.iconTheme"></i>
                                <i *ngIf="subItem.iconType == 'fontawesome'" class="m-r-10"
                                    [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                                <span>{{subItem.title}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</div>